import axios from '@/core/plugins/axios'
import storage from "@/core/services/storage.service";
import {DESTROY_VALIDATION_ERRORS} from "@/core/store/modules/errors/constants";
import store from '@/core/store'


axios.interceptors.request.use(
    function (config) {
         store.commit(DESTROY_VALIDATION_ERRORS)

        //region setAuthorizationHeader
        const token = storage.getToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        //endregion

        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);


